// extracted by mini-css-extract-plugin
export default {"font-size-regular":"15px","fontSizeRegular":"15px","productMoreDescription":"Tds0M"};